"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmPasswordInput = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var __1 = require("../..");
var passwordInput_1 = require("../passwordInput");
/** A password input that takes a bind and shows if the given value is different from the bound value */
exports.ConfirmPasswordInput = React.forwardRef(function (_a, ref) {
    var passwordsDontMatchMessage = _a.passwordsDontMatchMessage, errorIcon = _a.errorIcon, bind = _a.bind, validationMode = _a.validationMode, value = _a.value, onFocusProp = _a.onFocus, onBlurProp = _a.onBlur, onValueChange = _a.onValueChange, inputProps = tslib_1.__rest(_a, ["passwordsDontMatchMessage", "errorIcon", "bind", "validationMode", "value", "onFocus", "onBlur", "onValueChange"]);
    var _b = __1.Form.useBindingTools(bind, {
        value: value === null || value === void 0 ? void 0 : value.toString(),
        onChange: onValueChange,
        validationMode: validationMode,
        validationErrorIcon: errorIcon,
    }), boundValue = _b[0], bindConfig = _b[2];
    var _c = React.useState(''), inputValue = _c[0], setInputValue = _c[1];
    var _d = React.useState(false), showError = _d[0], setShowError = _d[1];
    var onBlur = React.useCallback(function (event) {
        if (boundValue && inputValue && inputValue !== boundValue) {
            setShowError(true);
            onBlurProp === null || onBlurProp === void 0 ? void 0 : onBlurProp(event);
        }
    }, [inputValue, boundValue]);
    var onFocus = React.useCallback(function (event) {
        setShowError(false);
        onFocusProp === null || onFocusProp === void 0 ? void 0 : onFocusProp(event);
    }, [onFocusProp]);
    return (React.createElement(passwordInput_1.PasswordInput, tslib_1.__assign({ onFocus: onFocus, onBlur: onBlur, value: inputValue, onValueChange: setInputValue }, inputProps, { ref: ref, validationErrorMessages: showError ? [passwordsDontMatchMessage] : [], errorIcon: bindConfig.validationErrorIcon, validationMode: bindConfig.validationMode })));
});
exports.ConfirmPasswordInput.defaultProps = {
    passwordsDontMatchMessage: "Passwords don't match",
};
